"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = void 0;
var _reactToastify = require("react-toastify");
var _is = require("../utils/is");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @Author: Alexander Silva Barbosa
 * @Date:   2023-05-04 13:22:31
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2023-05-08 00:49:27
 */
const Notifications = exports.Notifications = {
  TYPE_DEFAULT: _reactToastify.toast.TYPE.DEFAULT,
  TYPE_INFO: _reactToastify.toast.TYPE.INFO,
  TYPE_SUCCESS: _reactToastify.toast.TYPE.SUCCESS,
  TYPE_WARNING: _reactToastify.toast.TYPE.WARNING,
  TYPE_ERROR: _reactToastify.toast.TYPE.ERROR,
  COLOR_DEFAULT: '',
  COLOR_INFO: 'text-info',
  COLOR_SUCCESS: 'text-success',
  COLOR_WARNING: 'text-warning',
  COLOR_DANGER: 'text-danger',
  THEME_LIGHT: 'light',
  THEME_DARK: 'dark',
  THEME_COLORED: 'colored',
  items: {},
  handler: null,
  init: function () {
    let load = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (load) {
      const items = JSON.parse(localStorage.getItem('notifications'));
      if (items) this.items = items;
    }
  },
  get: function (id) {
    let group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (group == null) group = 'general';
    let item = null;
    for (let g in this.items) {
      if (group != null && g != group) continue;
      for (let i = 0; i < this.items[g].length; i++) {
        if (this.items[g][i].id == id) {
          item = this.items[g][i];
          break;
        }
      }
    }
    return item;
  },
  add: function (id, title_or_opts) {
    let text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    let icon = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    let color = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    let read = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    let title = title_or_opts;
    if ((0, _is.isObject)(title_or_opts)) {
      const opts = title_or_opts;
      title = opts.title;
      text = opts.text || text;
      group = opts.group || group;
      icon = opts.icon || icon;
      color = opts.color || color;
      read = opts.read;
      if (read === undefined) read = null;
    }
    if (group === null) group = 'general';
    if (!this.items[group]) this.items[group] = [];
    let item = this.get(id, group);
    if (item === null) {
      if (read === null) read = false;
      this.items[group].push({
        id: id,
        title: title,
        text: text,
        icon: icon,
        color: color,
        read: read
      });
    } else {
      if (title) item.title = title;
      if (text) item.text = text;
      if (icon) item.icon = icon;
      if (color) item.color = color;
      if (read !== null) item.read = read;
      this._set(id, item, group);
    }
    this._update();
  },
  remove: function (id) {
    let group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    for (let g in this.items) {
      if (group != null && g != group) continue;
      for (let i = 0; i < this.items[g].length; i++) {
        if (this.items[g][i].id == id) {
          this.items[g].splice(i, 1);
          i--;
        }
      }
    }
    this._update();
  },
  clear: function () {
    let group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (group == null) group = 'general';
    this.items[group] = [];
    this._update();
  },
  read: function (id) {
    let group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.add(id, {
      group: group,
      read: true
    });
  },
  toast: function (title_or_opts) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2000;
    let theme = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    let title = title_or_opts;
    if ((0, _is.isObject)(title_or_opts)) {
      const opts = title_or_opts;
      title = opts.title;
      type = opts.type || type;
      loading = opts.loading || loading;
      timeout = opts.timeout || timeout;
      theme = opts.theme || theme;
    }
    if (!type) type = Notifications.TYPE_DEFAULT;
    if (!theme) theme = Notifications.THEME_LIGHT;
    let options = {
      position: "top-right",
      autoClose: timeout || false,
      hideProgressBar: timeout == 0,
      type: type,
      closeOnClick: true,
      pauseOnHover: false,
      theme: theme
    };
    let id = null;
    if (loading) id = _reactToastify.toast.loading(title, options);else id = (0, _reactToastify.toast)(title, options);
    return id;
  },
  updateToast: function (id, title_or_opts) {
    let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2000;
    let theme = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    if (!id) return this.toast(title_or_opts, type, loading, timeout, theme);
    let title = title_or_opts;
    if ((0, _is.isObject)(title_or_opts)) {
      const opts = title_or_opts;
      title = opts.title;
      type = opts.type || type;
      loading = opts.loading || loading;
      timeout = opts.timeout || timeout;
      theme = opts.theme || theme;
    }
    if (!type) type = Notifications.TYPE_DEFAULT;
    if (!theme) theme = Notifications.THEME_LIGHT;
    let options = {
      render: title,
      isLoading: loading,
      autoClose: timeout || false,
      hideProgressBar: timeout == 0,
      type: type,
      closeOnClick: true,
      pauseOnHover: false,
      theme: theme
    };
    _reactToastify.toast.update(id, options);
  },
  clearToast: function (id) {
    _reactToastify.toast.dismiss(id);
  },
  onChange: function (handler) {
    this.handler = handler;
  },
  _set: function (id, item) {
    let group = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (group == null) group = 'general';
    for (let g in this.items) {
      if (group != null && g != group) continue;
      for (let i = 0; i < this.items[g].length; i++) {
        if (this.items[g][i].id == id) {
          this.items[g][i] = _objectSpread({}, item);
        }
      }
    }
  },
  _update: function () {
    localStorage.setItem('notifications', JSON.stringify(this.items));
    if (this.handler) {
      this.handler(_objectSpread({}, this.items));
    }
  }
};